import React from "react";
import ResetYourPassword from "./resetYourPassword";
class ResetYourPasswordParent extends React.Component {
  render() {
    return <ResetYourPassword />;
  }
}
export default ResetYourPasswordParent
